import OpenAI from 'openai';
import { OPEN_AI_KEY } from './constants';

const openai = new OpenAI({
  apiKey: "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",
  dangerouslyAllowBrowser:true,
});
export default openai;